import { render, staticRenderFns } from "./CliASelfService.vue?vue&type=template&id=1832b2ae"
import script from "./CliASelfService.vue?vue&type=script&lang=js"
export * from "./CliASelfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports